import { FilterOptions } from '../../filter.types';

export enum NumberRangeFilterTypes {
  PERCENTAGE = 'percentage',
  MONETARY = 'monetary',
  INTEGER = 'integer',
}

export interface NumberFilterValue {
  minValue: number;
  maxValue: number;
}

export interface NumberRangeFilterPropsV2
  extends Omit<FilterOptions<NumberFilterValue>, 'value' | 'onChange'> {
  type: NumberRangeFilterTypes;
  maxAvailableValue: number;
  minAvailableValue?: number;
  value: NumberFilterValue;
  onChange: (value: NumberFilterValue) => void;
  onValidationError?: (hasError: boolean) => void;
}
